<template>
  <section>
    <b-alert show v-if="!viewOnly">
      Lists the storefront products that are on backorder (available quantity below 0), as of the moment the report is generated.
    </b-alert>
    <b-row>
      <b-form-group class="col-12" label="Client:">
        <b-v-select
          :disabled="viewOnly"
          v-model="reportFilters.brandId"
          :searchable="true"
          :options="brandsFilter"
        />
      </b-form-group>
      <b-form-group class="col-12" label="Warehouse:">
        <b-v-select
          :disabled="viewOnly"
          v-model="reportFilters.warehouseId"
          :searchable="true"
          :options="warehousesListAll"
        />
      </b-form-group>
    </b-row>
  </section>
</template>

<script>
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  mixins: [myCommonDataMixin],
  name: 'ReportItemsOnBackorder-form',
  props: {
    reportFilters: {
      type: Object,
      required: true
    },
    viewOnly: {
      type: Boolean,
      default: false
    }
  }
}
</script>
